import { render } from "./ActivityBody.vue?vue&type=template&id=09892ac6"
import script from "./ActivityBody.vue?vue&type=script&lang=js"
export * from "./ActivityBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__